<script>
export let data = [{}];
export let restart_on = {};

$: {
    if(restart_on){
        data = [{}];
    }
}
</script>
{#each data as key (key)}
    <slot></slot>
{/each}